module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "danger"
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "type": "danger"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Download")])]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadWithAxios
    }
  }, [_vm._v("\n                                            Download List\n                                        ")])])]), _vm._v(" "), _c('panel', {
    staticClass: "text-left",
    attrs: {
      "header": "Panel #2",
      "type": "danger"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "create-account"
  }, [_c('h5', {
    staticClass: "margin-bot-20"
  }, [_vm._v("Select CSV File")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix gap"
  }), _vm._v(" "), _c('input', {
    ref: "myFileInput",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "file",
      "accept": ".csv",
      "id": "manageCoprPage"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "disabled": _vm.csv_file.length === 0,
      "type": "button"
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("\n                                            Upload\n                                        ")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.user.corporation.name))]), _c('p', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " (Admin)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v(" Download File => To get list of users in " + _vm._s(_vm.user.corporation.name) + "\n                                                ")]), _vm._v(" "), _c('li', [_vm._v(" Add attribues to users from downloaded file\n                                                ")]), _vm._v(" "), _c('li', [_vm._v(" Upload File => To synchronize changes in users with our records\n")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('br')])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                    Welcome to TONE. You are here to Manage your Community Page\n                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer hidemobile"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v("Tips to Upload/Download CSV Files")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('h6', {
    staticClass: "text-uppercase"
  }, [_vm._v("Note: First column of file should always be 'email'")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-339cc728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/ManagePage.vue